/*
 * @Author: RYL
 * @Description
 * @Date: 2020-10-16 14:20:14
 * @LastEditTime: 2020-12-25 09:44:44
 */
import http from '@/axios/http'
// 项目列表一级列表数据
export function getFirstGroup(data) {
  return http({
    method: 'post',
    url: `/api2/group/list`,
    data,
  })
}
// 项目列表二级列表数据
export function getSecondGroup(groupId) {
  return http({
    method: 'post',
    url: `/api2/group/lower/list`,
    data: {
      groupId,
    }
  })
}
// 条件搜索项目分组
export function queryGroup(data) {
  return http({
    // url: '/api2/group/query',
    url: '/api2/group/list',
    method: 'post',
    data,
  })
}
// 添加项目
export function addProjectGroup(data) {
  return http({
    method: 'post',
    url: `/api2/group/add`,
    data,
  })
}
// 编辑项目
export function editProjectGroup(data) {
  return http({
    method: 'post',
    url: `/api2/group/edit`,
    data,
  })
}

// 删除项目
export function deleteProjectGroup(groupId) {
  return http({
    method: 'post',
    url: `/api2/group/del`,
    data: {
      groupId,
    }
  })
}